const EVENT_NAMES = Object.freeze({
  OPENED: 'modal:opened',
  CLOSED: 'modal:closed',
});

const Events = {
  Opened(modalId) {
    const event = new CustomEvent(EVENT_NAMES.OPENED, {
      detail: modalId,
    });

    return event;
  },

  Closed(modalId) {
    const event = new CustomEvent(EVENT_NAMES.CLOSED, {
      detail: modalId,
    });

    return event;
  },
};

export { EVENT_NAMES, Events };
